import React from "react";
import { Image } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import "../CategoryMenu.css";

export default function CategoryMenu(props) {
  const { categories, setProducts, resetHandler } = props;
  const { pathname, search } = useLocation();
  return (
    <div className="categorymenu-menu-container">
      <ul className="categorymenu-menu">
        {categories.map((c) => (
          <li className="categorymenu-item" key={c._id}>
            <div className="categorymenu-card">
              <Link
                to={pathname + search}
                onClick={() => {
                  setProducts(c.products);
                  resetHandler();
                }}
              >
                <Image
                  className="categorymenu-image"
                  src={c.image}
                  alt={c.name}
                  fluid
                  rounded
                ></Image>
              </Link>

              <div className="categorymenu-overlay">
                <Link
                  to=""
                  className="categorymenu-link"
                  onClick={() => {
                    setProducts(c.products);
                    resetHandler();
                  }}
                >
                  <h6>{c.name}</h6>
                </Link>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
